<template>
  <v-menu class="mr-2" offset-y :close-on-content-click="false" :nudge-width="150" v-model="menu" transition="slide-y-transition">
    <v-avatar class="primary" size="30" slot="activator">
      <v-icon dark>support_agent</v-icon>
    </v-avatar>

    <v-card>
      <v-layout column justify-center class="address-list" v-for="(item, index) in headquarters" :key="index">
        <!-- <template v-for="(item, index) in headquarters"> -->
        <v-flex xs12 sm4 :class="{ 'mt-3': $vuetify.breakpoint.smAndDown }">
          <v-list two-line dense>
            <v-list-tile :href="`${item.addressLink}`" target="_blank" class="address-list-dense" @click="trackEvent(`'contacto_${item.city}_phone'`)">
                  <v-list-tile-action>
                    <v-icon>location_on</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.address1 }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.address2 }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
        <v-flex xs12 sm4 :class="{ 'mt-3': $vuetify.breakpoint.smAndDown }">
          <v-list two-line dense>
            <v-list-tile :href="`mailto:${item.email}`" class="address-list-dense" @click="trackEvent(`'contacto_${item.city}_email'`)">
                  <v-list-tile-action>
                    <v-icon>mail</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.email }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
        <v-flex xs12 sm4 :class="{ 'mt-3': $vuetify.breakpoint.smAndDown }">
          <v-list two-line dense>
            <v-list-tile :href="`tel:${item.phoneLink}`" class="address-list-dense" @click="trackEvent(`'contacto_${item.city}_phone'`)">
                  <v-list-tile-action>
                    <v-icon>phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.phone }}</v-list-tile-title>
                    <v-list-tile-sub-title><span v-html="item.phoneDescription"></span></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
        <!-- </template> -->
        </v-layout>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store';

export default {
  name: 'navigation-sidebar-bottom-contact',
  components: {},
  data() {
    return {
      user: store.state.user,
      menu: false
    };
  },
  computed: {
    countrySelected() {
      return store.state.countryConstantsSelected !== null;
    },
    headquarters() {
      if (this.countrySelected) {
        let index = store.state.headquarters.findIndex(item => item.country === store.state.countryConstantsSelected.country);
        let headquarter = [];
        headquarter[0] = store.state.headquarters[index];
        return headquarter;
      }
      return store.state.headquarters;
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
.address-list {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 8px;
}

.v-list__tile__action,
.v-list__tile__avatar {
   min-width: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/NavigationSidebarBottomContact.vue